export default {

  init() {
    document.addEventListener('alpine:init', () => {
      this.form();
    });
  },

  form() {

    Alpine.data('form', (options) => ({
      ...options,
      inputElements: [],
      inputErrors: [],
      invalidElements: [],
      ERROR_CLASS: 'invalid-feedback',
      DISABLED_CLASS: 'is-loading',

      init: function() {
        Iodine.setErrorMessage('required', "[FIELD] is required");

        Iodine.rule('emailList', this.emailListValidator);
        Iodine.setErrorMessage('emailList', 'Value must contain valid email addresses');

        this.$el.addEventListener('change', (event) => { this.handleChange(event, this) });
        this.$el.addEventListener('input', (event) => { this.handleChange(event, this) });

        this.inputElements = [...this.$el.querySelectorAll('[data-rules]')];
      },
      handleChange: function(event, scope) {
        scope.validateInput(event.target);
      },
      validateInput: function(el) {
        if(!el.dataset.rules) {
          return;
        }

        let result = Iodine.assert(el.value, JSON.parse(el.dataset.rules));
        let message = el.dataset.message ? el.dataset.message : result.error;
        this.inputErrors[el.name] = result.valid !== true ? message : '';

        this.updateErrorMessage(el);
      },
      validateAll: function() {
        this.inputElements = [...this.$el.querySelectorAll('[data-rules]')];
        this.invalidElements = [];

        this.inputElements.map((el) => {
          this.validateInput(el);
        });

        this.invalidElements = this.inputElements.filter((el) => {
          // Only validate visible elements
          return (
            el.offsetParent && Iodine.assert(el.value, JSON.parse(el.dataset.rules)).valid !== true
          );
        });
      },
      updateErrorMessage: function(el) {
        let error = this.inputErrors[el.name];
        let existingError = el.parentNode.querySelector(`ul.${this.ERROR_CLASS}`);

        if(existingError) {
          // Clear existing server or js errors
          existingError.remove();
        }

        if(error !== '') {
          // Add error element
          let errorElement = document.createElement('ul');
          errorElement.classList.add(this.ERROR_CLASS);
          let errorNode = document.createElement('li');
          errorElement.appendChild(document.createTextNode(error));
          el.parentNode.appendChild(errorElement);
        }
      },
      submit: function(event) {
        this.validateAll();
        let btn = event.submitter;

        if(this.invalidElements.length > 0) {
          event.preventDefault();
          this.invalidElements[0].parentNode.scrollIntoView({ behavior: 'smooth' });

          if(btn.type === 'submit') {
            btn.disabled = false;
            btn.classList.remove(this.DISABLED_CLASS);
          }
        } else {
          if(btn.type === 'submit') {
            btn.disabled = true;
            btn.classList.add(this.DISABLED_CLASS);
          }
        }
      },
      emailListValidator: function(value) {
        let emails = value.split(',').map((val) => val.trim());
        let isValid = true;

        emails.forEach((input) => {
          let result = Iodine.assert(input, ['email']);

          console.log(input, result);

          if(!result.valid && value.length > 0) {
            isValid = false;
          }
        });

        return isValid;
      }
    }));
  }
}
